export const info = {
    freshtaste: {
        title: "Fresh Taste"
    },
    madetoorder: {
        title: "Made To Order",
        text: "Every WHOPPER® Burger is made to order"
    },
    promotions: {
        title: "Promotions"
    },
    catering: {
        title: "Catering"
    }
}
